<template>
    <div
        ref="containerRef"
        class="lottie-canvas"
        :style="{ width: `${size}px`, height: `${size}px` }"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import lottie, { type AnimationItem } from 'lottie-web'
import locationMapAnimation from '@/assets/animations/location-map-animation.json'

export default defineComponent({
    name: 'LottieLoader',
    props: {
        size: { type: Number, default: 180 },
        loop: { type: Boolean, default: true },
        autoplay: { type: Boolean, default: true },
    },
    data() {
        return {
            animation: null as AnimationItem | null,
        }
    },
    mounted() {
        const container = this.$refs.containerRef as HTMLElement | undefined
        if (!container) return
        this.animation = lottie.loadAnimation({
            container,
            renderer: 'svg',
            loop: this.loop,
            autoplay: this.autoplay,
            animationData: locationMapAnimation as unknown as object,
        })
    },
    beforeDestroy() {
        this.animation?.destroy()
        this.animation = null
    },
})
</script>

<style scoped>
.lottie-canvas {
    pointer-events: none;
    filter: drop-shadow(0 10px 20px rgba(22, 101, 216, 0.22));
}
</style>
